import { render } from "./SingleTreeItemByContract.vue?vue&type=template&id=47711cb0"
import script from "./SingleTreeItemByContract.vue?vue&type=script&lang=js"
export * from "./SingleTreeItemByContract.vue?vue&type=script&lang=js"

import "./SingleTreeItemByContract.vue?vue&type=style&index=0&id=47711cb0&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__